module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navs"
  }, _vm._l((_vm.navs), function(nav) {
    return _c('div', {
      staticClass: "nav",
      class: {
        selected: _vm.selectedNav === nav
      },
      on: {
        "click": function($event) {
          _vm.onSelectNav(nav)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(nav.label))]), _vm._v(" "), _c('span', {
      staticClass: "line top"
    }), _vm._v(" "), _c('span', {
      staticClass: "line bottom"
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f4928a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collections/components/navs.vue
// module id = 197
// module chunks = 0